import { Injectable } from '@angular/core';
import { HttpService } from '../../utils/services/http.service';
import { Observable } from 'rxjs/Observable';
import { SessionStorage } from 'ngx-webstorage';
import { ErrorsService } from '../../utils/services/errors.service';

@Injectable()
export class LockedTimesheetService {

  constructor(private httpService: HttpService,
    private errorsService: ErrorsService) { }
  @SessionStorage() public user;

  /*Function to get employee locked list*/
  getLockedList(pageNumber): Observable<any> {
    const data = {
      'pageSize': 15,
      'pageNumber': pageNumber
    };
    return this.httpService.post(`employee/listLockedEmployees`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /*Function to unlock employee*/
  unLockTimeSheet(employees): Observable<any> {
    const data = {
      'employeeList': employees,
      userObj: {
        'EmailID': this.user.EmailID,
        'Empname': this.user.Empname
      }
    };
    return this.httpService.post(`employee/unlock`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /*Function to search employee*/
  searchFilter(term): Observable<any> {
    const data = {
      'pageSize': 15,
      'pageNumber': 1,
      'searchText': term
    };
    return this.httpService.post(`employee/lockList/search`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /*Function to handle observable error*/
  handleError(error: any) {
    this.errorsService.handleError(error);
    return Observable.throw(error.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/loked-timesheet/locked-timesheet.service.ts